// extracted by mini-css-extract-plugin
export default {"share":"Share-module__share--ev2jr","title":"Share-module__title--ZymWj","icons":"Share-module__icons--L70L8","icon":"Share-module__icon--ZrmkP"};